<template>
  <label class="radio">
    <input type="radio"
           :checked="shouldBeChecked"
           :value="value"
           @change="updateInput">
    <div class="radio__dummy">
      <div class="radio__dummy_circle"></div>
    </div>
    <span class="radio__label">{{label}}</span>
  </label>
</template>

<script>
/**
   * stylized radio button widget
   */
export default {
  name: 'BaseRadio',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: String,
    modelValue: {
      default: ''
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    shouldBeChecked () {
      return this.modelValue === this.value
    }
  },
  methods: {
    updateInput () {
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped lang="scss">
.radio {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  user-select: none;

  input {
    display: none;

    &:checked {
      & + div {
        color: $rfx-bright-blue;

        div {
          background-color: currentColor;
        }

        & + span {
          font-weight: bold;
          color: $rfx-dark-march;
        }
      }
    }
  }

  &__dummy {
    /*display: flex;*/
    width: 20px;
    height: 14px;
    flex: 0 0 14px;
    color: $rfx-silver;
    border: 2px solid currentColor;
    position: relative;
    border-radius: 50%;
    /*align-items: center;*/
    /*justify-content: center;*/
    margin-right: 8px;

    /*&::after {*/
    /*  content: '';*/
    /*  display: block;*/
    /*  width: 10px;*/
    /*  height: 10px;*/
    /*  border-radius: 50%;*/
    /*  background-color: transparent;*/
    /*}*/

    &_circle {
      width: 65%;
      height: 65%;
      border-radius: 50%;
      background-color: transparent;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: 0 -50% 0 0;
      transform: translate(-50%, -50%)
    }
  }

  &__label {
    display: block;
    color: $rfx-silver;
    font-size: 16px;
    @include ellipsis;
  }
}
</style>
